import useAssignUserPrivilegesController, { AppUser, Category } from "@/hooks/useAssignUserPrivilegesController ";
import { Button } from "@/shared";
import { Check, Pencil, ShieldCheck, X } from "lucide-react";

const AssignUserPrivileges = () => {
    const {
        t,
        users,
        isLoadingUsers,
        categories,
        previewPrivileges,
        editingUserId,
        draftCategoryId,
        setDraftCategoryId,
        isSaving,
        startEditing,
        cancelEditing,
        saveCategory,
    } = useAssignUserPrivilegesController();


    const getCategoryName = (id: string | number | null) =>
        categories.find((c: Category) => String(c.category_id) === String(id))?.category_name ?? t("no_category");

    return (
        <>
            {/* <Header title={t("assign_user_privileges")} /> */}
            {/* <main className="px-4 py-8 min-h-[calc(100vh-100px)] flex flex-col items-center justify-start"> */}
                <div className="w-full max-w-7xl">
                    <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
                        <div className="p-4 border-b border-slate-100 bg-slate-50/80 flex items-center gap-2">
                            <ShieldCheck className="w-5 h-5 text-violet-600" />
                            <h2 className="text-base font-bold text-slate-800">
                                {t("users_privileges")}
                            </h2>
                        </div>

                        <div className="overflow-x-auto">
                            <table className="w-full text-right border-collapse">
                                <thead>
                                    <tr className="text-slate-900 uppercase  font-black tracking-widest border-b border-slate-200 bg-slate-50/30">
                                        <th className="px-6 py-4">{t("user")}</th>
                                        <th className="px-6 py-4">{t("Role")}</th>
                                        <th className="px-6 py-4 ">{t("actions")}</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-slate-100">
                                    {isLoadingUsers && (
                                        <tr>
                                            <td colSpan={3} className="px-4 py-6 text-center text-slate-400">
                                                {t("loading")}
                                            </td>
                                        </tr>
                                    )}

                                    {users.map((user: AppUser) => {
                                        const isEditing = editingUserId === user.user_id;

                                        return (
                                            <tr key={user.user_id} className=" hover:bg-slate-50/50">
                                                <td className="px-4 py-3 font-medium text-slate-800 whitespace-nowrap">
                                                    {user.user_name}
                                                </td>

                                                <td className="px-4 py-3">
                                                    {isEditing ? (
                                                        <div className="space-y-2">
                                                            <select
                                                                value={draftCategoryId}
                                                                onChange={(e) => setDraftCategoryId(e.target.value)}
                                                                className="text-xs border border-slate-200 rounded-lg px-2 py-1.5 min-w-[160px]"
                                                            >
                                                                <option value="">{t("select_role")}</option>
                                                                {categories.map((c: Category) => (
                                                                    <option key={c.category_id} value={c.category_id}>
                                                                        {c.category_name}
                                                                    </option>
                                                                ))}
                                                            </select>

                                                            {draftCategoryId && previewPrivileges.length > 0 && (
                                                                <div className="flex flex-wrap gap-1.5 max-w-md">
                                                                    {previewPrivileges.map((p) => (
                                                                        <span
                                                                            key={p.privilegeid}
                                                                            className="px-2 py-0.5 rounded-md bg-violet-50 text-violet-700 text-[11px]"
                                                                        >
                                                                            {t(p.privilegedesc)}
                                                                        </span>
                                                                    ))}
                                                                </div>
                                                            )}
                                                        </div>
                                                    ) : (
                                                        <span className="px-2 py-1 rounded-md bg-violet-50 text-violet-700 text-xs font-medium">
                                                            {getCategoryName(user.category_id)}
                                                        </span>
                                                    )}
                                                </td>

                                                <td className="px-4 py-3  whitespace-nowrap">
                                                    {isEditing ? (
                                                        <div className="flex justify-end gap-2">
                                                            <Button
                                                                onClick={() => saveCategory(user.user_id)}
                                                                disabled={isSaving || !draftCategoryId}
                                                                loading={isSaving}
                                                                className="h-8 px-3 bg-slate-900 hover:bg-violet-700 text-white rounded-lg"
                                                            >
                                                                <Check className="w-4 h-4" />
                                                            </Button>
                                                            <Button
                                                                onClick={cancelEditing}
                                                                variant="outline"
                                                                className="h-8 px-3 border-slate-200 rounded-lg"
                                                            >
                                                                <X className="w-4 h-4" />
                                                            </Button>
                                                        </div>
                                                    ) : (
                                                        <Button
                                                            onClick={() => startEditing(user)}
                                                            variant="outline"
                                                            className="h-8 px-3 border-slate-200 text-slate-700 hover:bg-slate-50 rounded-lg"
                                                        >
                                                            <Pencil className="w-3.5 h-3.5 mr-1.5" />
                                                            {t("edit")}
                                                        </Button>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            {/* </main> */}

        </>
    );
};

export default AssignUserPrivileges;